import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { UserDetailsComponent } from './user-details/user-details.component';
import { InvoiceDetailsTableComponent } from './invoice-details-table/invoice-details-table.component';
import { InvoiceDetailsService } from '../services/invoice-details.service';
import { Invoice } from '../models/invoice-details.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-invoice-details',
    imports: [
        RouterLink,
        UserDetailsComponent,
        InvoiceDetailsTableComponent,
        TranslatePipe
    ],
    templateUrl: './invoice-details.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './invoice-details.component.scss'
})
export class InvoiceDetailsComponent implements OnInit {
    invoice?: Invoice;

    constructor(
        private route: ActivatedRoute,
        private invoiceDetailsService: InvoiceDetailsService
    ) {}

    ngOnInit(): void {
        const id = this.route.snapshot.paramMap.get('id')!;
        this.invoiceDetailsService
            .getInvoiceDetailsById(id)
            .subscribe(invoice => {
                this.invoice = invoice;
            });
    }
}
